<div class="frameContainer">
  <div
    class="frame clickable"
    (click)="onToggleDetail()"
    [class.toggled]="toggled"
    [class.noClickFrame]="noClick"
  >
    <ng-content select="[header]"></ng-content>
  </div>
  <div class="detailContainer" [class.open]="toggled" detail>
    <div class="detailWrapper" [class.show]="toggled">
      <ng-content select="[detail]"></ng-content>
    </div>
  </div>
</div>
